export default __webpack_public_path__ + "static/media/order.778e5a63.svg";